exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-row[data-v-59e3a05c]{width:100%}.display-row[data-v-59e3a05c],.edit-row[data-v-59e3a05c]{display:inline-block}", ""]);

// exports
